
/* eslint-disable @typescript-eslint/no-explicit-any */
import { PROVIDER_CONSTANTS } from '@/constants/provider.constants'
import { ServiceService } from '@/services/service.service'
import { defineComponent, inject } from 'vue'
import LoadingPulse from '@/components/shared/LoadingPulse.vue'
import { Service } from '@/@types/responses/service/Service'
import Toaster from '@meforma/vue-toaster'
import { ErrorsResponse } from '@/@types/responses/common/ErrorsResponse'

export default defineComponent({
  name: 'ServiceSearchMachine',
  components: {
    LoadingPulse
  },
  emits: [
    'service'
  ],
  setup() {
    const serviceService = inject(PROVIDER_CONSTANTS.serviceService) as ServiceService
    const toast = inject(PROVIDER_CONSTANTS.toaster) as Toaster
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    function createDebounce() {
      let timeout: number|undefined = undefined
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      return function (func: any, delay?: number|undefined) {
        clearTimeout(timeout)
        timeout = setTimeout(() => { func() }, delay || 500)
      }
    }
    return {
      debounce: createDebounce(),
      serviceService,
      toast
    }
  },
  data() {
    return {
      searching: false,
      searchTerm: '',
      searchResults: [] as Service[]
    }
  },
  computed: {
    showResults(): boolean {
      return this.searchTerm !== '';
    }
  },
  methods: {
    chooseOption(service: Service): void {
      this.searchTerm = ''
      this.$emit('service', service)
    },
    getHighlightedService(): Service|undefined {
      const highlightedService = this.searchResults.filter(s => s.highlighted);
      return highlightedService.length > 0 ? highlightedService[0] : undefined;
    },
    onClickOutside(): void {
      this.searchTerm = ''
    },
    onDownArrowPressed(): void {
      const highlightedService = this.getHighlightedService();

      let nextIndex = highlightedService ? this.searchResults.indexOf(highlightedService) + 1 : 0;
      if (nextIndex > this.searchResults.length - 1)
        nextIndex = 0;
      
      if (highlightedService)
        highlightedService.highlighted = false;

      this.searchResults[nextIndex].highlighted = true;
    },
    onEnterPressed(): void {
      const highlightedService = this.getHighlightedService();
      if (highlightedService)
        this.chooseOption(highlightedService)
    },
    onSearchTermChanged(): void {
      if (this.searchTerm !== '') {
        this.searching = true
        this.debounce(this.searchServices)
      }
    },
    onUpArrowPressed(): void {
      const highlightedService = this.getHighlightedService();
      let previousIndex = highlightedService ? this.searchResults.indexOf(highlightedService) - 1 : 0;

      if (previousIndex < 0)
        previousIndex = this.searchResults.length - 1;

      if (highlightedService)
        highlightedService.highlighted = false;

      this.searchResults[previousIndex].highlighted = true;
    },
    searchServices(): void {
      this.serviceService.searchServices(this.searchTerm, 1, 25, 'Name', undefined, true).then(pagingResponse => {
        this.searchResults = pagingResponse.results
        this.searching = false
      }).catch(error => {
        if (error instanceof ErrorsResponse) {
          const errorsResponse = error as ErrorsResponse

          if (errorsResponse.errors.some(e => e.id === 33001 || e.id === 33002 || e.id === 33003)) return

          this.toast.error(errorsResponse.errors.map(e => e.message).join("\r\n"))
        } else {
          this.toast.error(`Failed to search for your services. Please try again.`)
        }
      })
    }
  }
})
